export default __webpack_public_path__ + "static/media/screenshot1.5aa19bb7.png";